// Shared JSON-LD structured data for rich search results.
const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://stallionbulktech.com';
const LOGO_URL =
  'https://customer-assets.emergentagent.com/job_add4c97a-cab7-4cb4-a1cf-0b5112bb0652/artifacts/zur5e9w0_Stallion%20Bulktech.png';

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Stallion Bulktech',
  legalName: 'Stallion Bulktech',
  url: SITE_URL,
  logo: LOGO_URL,
  description:
    'India-based manufacturer and execution partner specialising in industrial machine guards, dust suppression systems, and wear resistance solutions for mining, cement, power, and bulk material handling industries.',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Plot No 4, Gatrad – Vanch Road',
    addressLocality: 'Gatrad, Ahmedabad',
    postalCode: '382449',
    addressCountry: 'IN',
  },
  contactPoint: [
    {
      '@type': 'ContactPoint',
      telephone: '+91-7041365465',
      contactType: 'sales',
      areaServed: 'IN',
      availableLanguage: ['en', 'hi'],
    },
  ],
  sameAs: [],
};

export const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'Stallion Bulktech',
  image: LOGO_URL,
  url: SITE_URL,
  telephone: '+91-7041365465',
  email: 'info@stallionbulktech.com',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Plot No 4, Gatrad – Vanch Road',
    addressLocality: 'Ahmedabad',
    addressRegion: 'Gujarat',
    postalCode: '382449',
    addressCountry: 'IN',
  },
  priceRange: 'Quote on request',
};

export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Stallion Bulktech',
  url: SITE_URL,
};

export const breadcrumb = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: item.name,
    item: `${SITE_URL}${item.path}`,
  })),
});

export const productSchema = (product) => ({
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: product.name,
  description: product.shortDescription,
  image: product.images || [product.image],
  category: product.category,
  brand: {
    '@type': 'Brand',
    name: 'Stallion Bulktech',
  },
  manufacturer: {
    '@type': 'Organization',
    name: 'Stallion Bulktech',
    url: SITE_URL,
  },
});
